import { render } from "./timeline-week.view.vue?vue&type=template&id=279ed356&scoped=true"
import script from "./timeline-week.view.vue?vue&type=script&lang=js"
export * from "./timeline-week.view.vue?vue&type=script&lang=js"

import "./timeline-week.view.vue?vue&type=style&index=0&id=279ed356&scoped=true&lang=css"

import exportComponent from "/home/smileythane/Projects/ixarma-ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-279ed356"]])

export default __exports__